{
  "auth": {
    "Adventure starts here 🚀": "Macera burada başlıyor 🚀",
    "Already have an account?": "Zaten bir hesabınız var mı?",
    "Back To Home": "Ana Sayfaya Geri Dön",
    "Back to login": "Girişe Dön",
    "Confirm Password": "Şifre Kontrol",
    "Doğrula": "Doğrula",
    "Doğrulama Kodu": "Doğrulama Kodu",
    "Forgot Password? 🔒": "Şifremi Unuttum?",
    "Geri Dön": "Geri Dön",
    "Google Authenticator Kodu": "Google Authenticator Kodu",
    "I agree to": "Kabul ediyorum",
    "Login": "Giriş",
    "New Password": "Yeni Şifre",
    "Password Check": "Şifre Kontrol",
    "Phone": "Telefon",
    "Remember me": "Beni Hatırla",
    "Reset Password": "Şifreyi Sıfırla",
    "Application Title": "Sigorta Takip Sistemi",
    "logout_message": "Güvenle çıkış yapılıyor...",
    "register_title": "Kayıt Ol",
    "register_description": "Yeni bir hesap oluşturun ve avantajları keşfedin",
    "i_accept": "kabul ediyorum",
    "join_us": "Bize Katılın",
    "join_us_description": "Hemen kaydolun ve profesyonel ağımıza dahil olarak avantajlı dünyamıza adım atın.",
    "Send Reset Link": "Şifre Sıfırlama Gönder",
    "Set New Password": "Yeni Şifre Belirleme",
    "Sign in instead": "Bunun yerine giriş yap",
    "Sign up": "Kayıt Ol",
    "You are not authorized! 🔐": "Yetkiniz yok! 🔐",
    "PermissionDenied": "Bu sayfaya erişim izniniz yok. Ana Sayfaya Dönün!",
    "privacy policy & terms": "Gizlilik Politikası'nı okudum ve kabul ediyorum. Kişisel verilerimin işlenmesine onay veriyorum.",
    "Form gönderilirken bir hata oluştu:": "Form gönderilirken bir hata oluştu:",
    "Welcome": "Hoşgeldiniz {title}",
    "Soru": "Soru",
    "Cevap": "Cevap",
    "Email": "E-posta",
    "Password": "Şifre",
    "Ad Soyad": "Ad Soyad",
    "Forgot Password Description": "E-posta adresinizi girin, şifrenizi sıfırlamanız için size talimatlar göndereceğiz.",
    "Your new password must be different from previously used passwords": "Yeni şifreniz daha önce kullanılan şifrelerden farklı olmalıdır.",
    "Lütfen 6 haneli güvenlik kodunu girin": "Lütfen 6 haneli güvenlik kodunu girin",
    "İki Adımlı Doğrulama": "İki Adımlı Doğrulama",
    "Doğrulama kodu gönderildi": "Doğrulama kodu gönderildi.",
    "Kodu almadınız mı?": "Kodu almadınız mı?",
    "New on our platform?": "Platformumuzda yeni misiniz?",
    "Create an account": "Bir hesap oluşturun",
    "Make your app management easy and fun!": "Uygulama yönetiminizi kolay ve eğlenceli hale getirin!",
    "Privacy Policy Title": "Gizlilik Politikası ve Şartlar",
    "Please Login": "Devam etmek için hesabınıza giriş yapın",
    "Switch Account": "Farklı bir hesapla giriş yap",
    "Welcome Back": "Hoş Geldiniz",
    "Invalid Captcha": "Güvenlik Kodunu Kontrol Ediniz.",
    "Login Title": "Giriş Yap",
    "Back to Login Page": "Giriş Sayfasına Dön",
    "Last updated": "Son Güncelleme",
    "Hava Açık": "Hava Açık",
    "Az Bulutlu": "Az Bulutlu",
    "Parçalı Bulutlu": "Parçalı Bulutlu",
    "Kapalı": "Kapalı",
    "Sisli": "Sisli",
    "Çiseleme": "Çiseleme",
    "Yağmurlu": "Yağmurlu",
    "Hafif Yağmur": "Hafif Yağmur",
    "Şiddetli Yağmur": "Şiddetli Yağmur",
    "Kar Yağışlı": "Kar Yağışlı",
    "Fırtına": "Fırtına",
    "Bilinmiyor": "Bilinmiyor",
    "Hissedilen": "Hissedilen",
    "Veri yükleniyor...": "Veri yükleniyor...",
    "Gündüz": "Gündüz",
    "Gece": "Gece",
    "Şimdi Yenile": "Şimdi Yenile"
  }
}
